/*
 * File: d:\projects\AutoFiFront\src\Content\SynchroCar\SynchroCar.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Tuesday April 11th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday, 24th November 2023 09:08:22
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React, { useEffect, useRef, useState } from 'react';
import translator from 'MultiLanguage/TranslationWrapper';
import styles from "Content/SynchroCar/SynchroCar.module.css";
import Cookie from "Cookies/CookieWrapper";
import CookiePathResolver from 'Config/Cookies/CookiePathResolver';
import { useNavigate } from 'react-router-dom';
import CarService from 'Services/Cars/CarService';
import JSZip from 'jszip';
import RouterPathResolver from 'Config/Router/RouterPathResolver';
import LoadingScreen from 'Content/LoadingScreen/LoadingScreen';

function SynchroCar(_:any) {
    const navigate = useNavigate();
    const myCookie: string = Cookie.getCookie(CookiePathResolver.USER.TOKEN);
    const [carFile, setCarFile] = useState<File>();
    // const [picFile, setPicFile] = useState<File>();
    const [myResultArr, setMyResultArr] = useState<{[key:string]: string }>({});
    // let [myResultArr2, setMyResultArr2] = useState<{[key:string]: string }>({});
    const [myResultCar, setMyResultCar] = useState<{name: string, elem: JSX.Element}[]>();
    const ref = useRef<HTMLInputElement>(null);
    const [spinner, setSpinner] = useState(false);

    useEffect(()=>{
        if (myCookie == ""  || myCookie == undefined)
            navigate(RouterPathResolver.routeCars.path);
    },[]);

    // useEffect(() => {
    //     if (ref.current !== null) {
    //       ref.current.setAttribute("directory", "");
    //       ref.current.setAttribute("webkitdirectory", "");
    //     }
    //   }, [ref]);

    useEffect(() => {
        const myRes: {name: string, elem: JSX.Element}[] = [];
        for (const immatOrVin in myResultArr) {
            myRes.push({name: immatOrVin, elem: <div key={immatOrVin} className={`${(myResultArr[immatOrVin].includes("à jour") || myResultArr[immatOrVin].includes("créée")) ? styles.resultOk : styles.resultBad }`}>{immatOrVin} : {myResultArr[immatOrVin]}</div>});
        }
        setMyResultCar(myRes);
    }, [myResultArr]);

    // useEffect(() => {
    //     const tmp: {[key: string]: string} = {};
    //     for (const immat in myResultArr)
    //         tmp[immat] = myResultArr[immat];
    //     // for (const immatOrVin in myResultArr2) {
    //     //     if (tmp[immatOrVin])
    //     //         tmp[immatOrVin] += `.\tPictures: ${myResultArr2[immatOrVin]}`;
    //     //     else
    //     //         tmp[immatOrVin] = `.\tPictures: ${myResultArr2[immatOrVin]}`;
    //     // }
    //     setMyResultArr(tmp);
    // }, [myResultArr]);

    // const onZip = () => {
    //     const zip = new JSZip();
    //     const files = Array.from(ref.current!.files!);
    //     files.forEach((file) => {
    //         zip.file(file.webkitRelativePath, file);
    //     });
    //     zip
    //     .generateAsync({ type: "blob" })
    //     .then(function (content) {
    //         const formData = new FormData();
    //         formData.append("folderzip", content);
    //         const myRet = CarService.sendPicZip(formData);
    //         myRet.then((y)=>{
    //             myResultArr2 = {};
    //             for (const idx in y) {
    //                 const immatOrVin = Object.keys(y[idx])[0];
    //                 const tmp = immatOrVin.toLocaleUpperCase();
    //                 myResultArr2[tmp] = y[idx][immatOrVin];
    //             }
    //             setMyResultArr2(myResultArr2);
    //             setSpinner(false);
    //         });
    //     })
    //     .catch((e) => {console.log(e); setSpinner(false);});
    // };

    function setCar(e:any){
        setCarFile(e.target.files[0]);
    };
    // function setPic(e:any){
    //     setPicFile(e.target.files[0]);
    // };
    async function handleSubmit(e: any){
        e.preventDefault();
        setSpinner(true);
        if (carFile != undefined){
            try {
                const myRet = await CarService.sendCarFile(carFile);
                setMyResultArr(myRet);
                setSpinner(false);
            } catch (err: any) {
                console.log(err);
                if (err.response && err.response.data)
                    setMyResultArr(err.response.data)
                else
                    setMyResultArr(({['Erreur']: 'Une erreur s\'est produite.'}));
                setSpinner(false);
            }
        }
        // if (picFile != undefined) {
        //     setSpinner(true);
        //     onZip();
        // }
    };

    return (
        <React.Fragment>
            {
                myCookie != ""  && myCookie != undefined ? <div className={`${styles.synchroCar}`}>
                                    <h2 className={`${styles.title}`}>{translator.decode("synchro.title")}</h2>
                                    <form>
                                        <label htmlFor="carFile"> {translator.decode('synchro.carFile')} </label>
                                        <br/>
                                        <input className={`${styles.inputFile}`} id='carFile' onChange={setCar} type="file" accept=".xlsx, .xls, .csv" />
                                        <br/>
                                        {/* <br/>
                                        <label htmlFor="picFile"> {translator.decode('synchro.picFile')} </label>
                                        <br/>
                                        <input className={`${styles.inputFile}`} id='picFile' onChange={setPic} type="file" ref={ref} />
                                        <br/>
                                        <br/> */}
                                        <button className={`${styles.buttonSend}`} type="submit" onClick={handleSubmit}> {translator.decode("synchro.send")} </button>
                                    </form>
                                </div>
                                :null
            }
            {
                spinner ? <LoadingScreen /> : <div className={`${styles.showResult}`}> {myResultCar?.sort((a, b) => a.name.localeCompare(b.name, "fr", {numeric: true})).map((x) => x.elem)} </div>
            }

        </React.Fragment>
    );
}

export default SynchroCar;
